// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"25":"ea955de8","221":"bb5c64e3"}[chunkId] + ".chunk.css";
};